import MegaNavDesktop from './mega-nav-desktop';
import MegaNavMobile from './mega-nav-mobile';
import { NavigationMenu, PageReference } from '../../../typescript/response';
import { CSLocale } from '../../../typescript/component';

interface MegaNavProps {
  navMenu: NavigationMenu[];
  isMobile?: boolean;
  isOpenMobileSideBar?: boolean;
  handleCloseSideBar?: (arg: boolean) => void;
  isMenuLevelTwoOpened: boolean;
  handleMenuLevelTwoOpened: (arg: boolean) => void;
  showLanguageSelector?: boolean;
  languages: CSLocale[] | null;
  currentLocale: string;
  currentPath: string;
  onLocaleChange: (newLocale: string) => void;
  locations?: PageReference;
  request_quote: PageReference;
  contact_us: PageReference;
}

export default function MegaNav(props: MegaNavProps) {
  return props.isMobile ? <MegaNavMobile {...props} /> : <MegaNavDesktop {...props} />;
}
